import React from 'react';

/* Faint tiled "LICENCED · <email>" watermark over licenced tools. Shared. */
export default function Watermark({ email }) {
  const text = `LICENCED · ${(email || 'NARRATORIA').toUpperCase()} · `;
  return (
    <div aria-hidden style={{ position:'fixed',inset:0,pointerEvents:'none',zIndex:9999,overflow:'hidden',userSelect:'none' }}>
      {Array.from({ length: 18 }).map((_, i) => (
        <div key={i} style={{
          position:'absolute', fontSize:'10px', color:'rgba(212,175,55,0.07)', fontWeight:700,
          letterSpacing:'0.06em', transform:'rotate(-28deg)', whiteSpace:'nowrap',
          top:`${(i % 6) * 17}%`, left:`${Math.floor(i / 6) * 36 - 10}%`,
        }}>{text.repeat(5)}</div>
      ))}
    </div>
  );
}
